export default __webpack_public_path__ + "static/media/BlueLeft.27c16450.png";